import React from 'react';
import { Alert, Button } from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';
import { useCustomer } from '../../../contexts/CustomerContext';
import { useSignInDialog } from '../../auth/SignInDialog';

// Banner shown above Step 1 of checkout when the user is not signed in.
// Single CTA; never blocks guest checkout. Hidden entirely once signed in
// so the page stays uncluttered.
const CheckoutSignInBanner: React.FC = () => {
  const { user, loading } = useCustomer();
  const { openSignIn } = useSignInDialog();

  if (loading || user) return null;

  return (
    <Alert
      severity="info"
      sx={{ mb: 2 }}
      action={
        <Button
          color="inherit"
          size="small"
          onClick={openSignIn}
          startIcon={<LoginIcon />}
          sx={{ textTransform: 'none' }}
        >
          Sign in
        </Button>
      }
    >
      Sign in to earn points and save your info for next time.
    </Alert>
  );
};

export default CheckoutSignInBanner;
